import { Component, Input, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-scene-detail-clips',
    templateUrl: './scene-detail-clips.component.html',
    styleUrls: ['./scene-detail-clips.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SceneDetailClipsComponent implements OnInit {

	@Input() clips: any = [];
	@Input() loading: boolean = true;

	showSelected: boolean = false;
	view: string = 'home';
	imagePosition: number = 0;
	filteredClips: any[] = [];

	viewSlider(pos) {
		this.view = 'slider';
		this.imagePosition = pos;
	}
	validateShowSelected() {
		this.filteredClips = JSON.parse(JSON.stringify(this.clips));
		if (!this.showSelected) {
			this.filteredClips = this.filteredClips.filter(clip => clip.selected_clip);
			return;
		}
	}

	constructor() { }

	ngOnInit(): void {
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.clips && this.clips) {
			this.filteredClips = JSON.parse(JSON.stringify(this.clips));
		}
	}

}
